import { Suspense, lazy } from 'react';
import { ROUTE_CONFIG } from '../config/routes';
import PrivateRoute from '../modules/auth/PrivateRoute';
import ErrorBoundary from '../modules/core/shared/components/ErrorBoundary';
import BrandLoader from '../modules/core/components/Brand/BrandLoader';

const PlanGuard = lazy(() => import('../shared/components/PlanGuard'));

const GenerateRoutes = (userPermissions) => {


  const permissionsMap = () => {
    const map = new Map();

    if (!userPermissions) return map;


    userPermissions.forEach(role => {
      // const key = `${permission.module}:${permission.actions.join(',')}`;
      // map.set(key, true);
      // map.set(permission.module, permission.actions);

      role.forEach(permission => {
        // const key = `${permission.module}:${permission.actions.join(',')}`;
        // map.set(key, true);
        const existing = map.get(permission.module) || [];
        map.set(permission.module, [...new Set([...existing, ...permission.actions])]);
        //  map.set(permission.module, permission.actions);

      });
    });

    // console.log('GenerateRoutes Permissions Map:', map);
    return map;
  }

  return ROUTE_CONFIG.map(route => {
    // Skip permission check for public routes
    if (!route.module) {
      return {
        path: route.path,
        element: (
          <ErrorBoundary>
            <Suspense fallback={<BrandLoader message="Synchronizing Module..." />}>
              <route.component />
            </Suspense>
          </ErrorBoundary>
        )
      };
    }


    const moduleActions = permissionsMap().get(route.module);

    if (!moduleActions) {

      return null;
    }

    const actionSet = new Set(moduleActions);
    const result = Array.isArray(route.actions)
      ? route.actions.some(act => actionSet.has(act))
      : actionSet.has(route.actions);

    // console.log('GenerateRoutes route.actions:', route?.actions);
    // console.log('GenerateRoutes actionSet:', actionSet);
    // console.log('GenerateRoutes Result:', result);

    if (!result) return null

    // Check permissions for protected routes
    //const modulePermissions = userPermissions?.[route.module];
    // console.log('route.module:', route);
    // console.log('Module Permissions:', modulePermissions);
    //const hasAccess = hasPermission(route.module, route.actions);
    // const hasAccess = modulePermissions && route.actions.some(action => 
    //   modulePermissions.includes(action)
    // );

    // if (!hasAccess) return null;

    return {
      actions: actionSet,
      module: route.module,
      path: route.path,
      element: (
        <ErrorBoundary>
          <PrivateRoute
            requiredModule={route.module}
            requiredAction={route.actions}
          >
            <Suspense fallback={<BrandLoader message="Synchronizing Module..." />}>
              {route.requiredPlan ? (
                <PlanGuard
                  requiredPlan={route.requiredPlan}
                  featureName={route.featureName}
                  description={route.description}
                >
                  <route.component />
                </PlanGuard>
              ) : (
                <route.component />
              )}
            </Suspense>
          </PrivateRoute>
        </ErrorBoundary>
      )
    };
  }).filter(Boolean); // Remove null routes
};

// Helper to get navigation menu items
const getNavigationItems = (routes) => {
  return ROUTE_CONFIG
    .filter(route => {
      if (!route.path) return false;

      return routes.some(r => r.path === route.path);
    })
    .map(route => ({
      path: route.path,
      label: route.label,
      icon: route.icon,
      group: route.group
    }));
};

// Helper to group routes by module
const groupRoutesByModule = (routes) => {
  return routes.reduce((groups, route) => {
    const group = route.metadata?.group || 'other';
    if (!groups[group]) groups[group] = [];
    groups[group].push(route);
    return groups;
  }, {});
};

export { GenerateRoutes, getNavigationItems, groupRoutesByModule };